import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { setLocale, SUPPORTED_LOCALES, DEFAULT_LOCALE, resolveInitialLocale } from '../i18n/index.js';

export const useLocaleStore = defineStore('locale', () => {
  const locale = ref(resolveInitialLocale());

  const isEnglish = computed(() => locale.value === 'en');
  const isChinese = computed(() => locale.value === 'zh');

  function switchLocale(newLocale) {
    if (!SUPPORTED_LOCALES.includes(newLocale) || newLocale === locale.value) return;
    setLocale(newLocale);
    locale.value = newLocale;
  }

  function toggleLocale() {
    switchLocale(locale.value === 'en' ? 'zh' : 'en');
  }

  return {
    locale,
    isEnglish,
    isChinese,
    switchLocale,
    toggleLocale,
    supportedLocales: SUPPORTED_LOCALES,
    defaultLocale: DEFAULT_LOCALE,
  };
});
